import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';


@Injectable({
	providedIn: 'root'
})
export class AuthGuard  {

	
	// ---- Constructor ---- \\
	constructor(
		private auth: AuthenticationService,
		private router: Router
	){}



	// ---- Public methods --- \\
	
	public async canActivate(): Promise<boolean> {
		return this.checkAuthentication();
	}

	public async canActivateChild(): Promise<boolean> {
		return this.checkAuthentication();
	}

	

	// ---- Private methods --- \\

	private async checkAuthentication(): Promise<boolean> {
		const check = await this.auth.validateToken();
		if (check === true) {
			return true;
		} else {
			this.router.navigate(['/login']);
			return false;
		}
	}
}